import { useState } from "react";
import { AlertTriangle } from "lucide-react";

import { Button } from "@/components/ui/Button";
import { cn } from "@/lib/utils";
import { useHubModuleWrite } from "@/lib/useHubModuleWrite";

import { KittingInventoryDiscrepancyModal } from "./KittingInventoryDiscrepancyModal";

export function KittingInventoryDiscrepancyButton({
  initialSku = "",
  transferOrderId = null,
  transferOrderItemId = null,
  disabled = false,
  className,
}: {
  initialSku?: string;
  transferOrderId?: number | null;
  transferOrderItemId?: number | null;
  disabled?: boolean;
  className?: string;
}): JSX.Element {
  const canWrite = useHubModuleWrite("manufacturing");
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        type="button"
        variant="secondary"
        size="sm"
        className={cn("gap-1.5", className)}
        disabled={!canWrite || disabled}
        aria-label="Note inventory discrepancy"
        onClick={() => setOpen(true)}
      >
        <AlertTriangle className="h-4 w-4" aria-hidden />
        <span className="xl:hidden">Discrepancy</span>
        <span className="hidden xl:inline">Note inventory discrepancy</span>
      </Button>
      <KittingInventoryDiscrepancyModal
        open={open}
        initialSku={initialSku}
        transferOrderId={transferOrderId}
        transferOrderItemId={transferOrderItemId}
        onClose={() => setOpen(false)}
      />
    </>
  );
}
